import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";

export default function NotificationBell({ className = "" }) {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setCount(data.unread_count || 0);
    } catch { /* not authed yet */ }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 20000);
    const onRead = () => setCount(0);
    window.addEventListener("notif-read", onRead);
    return () => { clearInterval(id); window.removeEventListener("notif-read", onRead); };
  }, [refresh]);

  return (
    <button data-testid="notif-bell-button" onClick={() => navigate("/notifications")} aria-label="Notifications"
      className={`relative inline-flex items-center justify-center h-10 w-10 rounded-full border border-[#291B2D]/10 bg-white text-[#291B2D]/70 hover:text-[#291B2D] hover:bg-[#F7F2EA] transition-smooth ${className}`}>
      <Bell size={16} strokeWidth={1.75} />
      {count > 0 && (
        <span data-testid="notif-unread-badge"
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#B97978] text-white text-[10px] font-bold flex items-center justify-center">
          {count > 9 ? "9+" : count}
        </span>
      )}
    </button>
  );
}
